"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var getElement = function getElement(element) {
  if (!element) {
    return null;
  }
  return document.getElementById(element);
};
var _default = getElement;
exports.default = _default;